import React from 'react';

const Photos = React.lazy(() => {
  return import('./Photos');
});

const Measures = React.lazy(() => {
  return import('./Measures');
});

const VirtualVisit = React.lazy(() => {
  return import('./VirtualVisit');
});

const Videos = React.lazy(() => {
  return import('./Videos');
});

const DetailedFloorplanMedias = React.lazy(() => {
  return import('./DetailedFloorplanMedias');
});

const MlsManager = React.lazy(() => {
  return import('./MlsManager');
});

const ThumbnailList = React.lazy(() => {
  return import('./ThumbnailList');
});

const ListingDescriptionGeneration = React.lazy(() => {
  return import('./ListingDescriptionGeneration');
});

const MovingWaldoContent = React.lazy(() => {
  return import('./MovingWaldoContent');
});

const AiStagingOrder = React.lazy(() => {
  return import('./AiStagingOrder');
});

export { default as Header } from './Header';
export { default as Navigator } from './Navigator';
export { default as ChipsInput } from './ChipsInput';
export { default as TextGenerator } from './TextGenerator';
export { default as PreviousDescriptions } from './PreviousDescriptions';

export { default as ModalStepper } from './ModalStepper';
export { default as SlideshowModalStepper } from './SlideshowModalStepper';
export { default as VirtualTourExamples } from './VirtualTourExamples';

export {
  Photos,
  Measures,
  VirtualVisit,
  Videos,
  DetailedFloorplanMedias,
  MlsManager,
  ThumbnailList,
  ListingDescriptionGeneration,
  MovingWaldoContent,
  AiStagingOrder,
};
